import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestStateService {
  private counter = 0;
  readonly requestStarter = new Subject<void>();
  readonly requestStoped = new Subject<void>();

  start(): void {
    const cnt = this.counter++;
    if (cnt <= 0) {
      this.requestStarter.next();
    }
  }

  stop(): void {
    if (this.counter > 0) {
      this.counter--;
    }
    if (this.counter == 0) {
      this.requestStoped.next();
    }
  }
}
